import notificationImage from "../../../../common/images/notification.svg";
import {
    NotificationWidget,
    EmptyWidget,
} from "@hatch-digital-nl/abs-storybook/legacy";
import Skeleton from "react-loading-skeleton";
import { useNavigate } from "react-router";
import { JSX } from "react";
import { RouteEnum } from "../../../../common/enums/RouteEnum";
import { useDashboardEmployeeNotifications } from "../../hooks/useDashboardEmployeeNotifications";

export const DashboardEmployeeNotifications = (): JSX.Element => {
    const navigate = useNavigate();
    const { loading, isEmpty, viewData } = useDashboardEmployeeNotifications();

    if (loading) {
        return <Skeleton height={"37rem"} borderRadius={"1.5rem"} />;
    }

    if (isEmpty) {
        return (
            <EmptyWidget
                title={"Belangrijke meldingen"}
                content={"Er zijn nog geen belangrijke meldingen"}
                svgUrl={notificationImage}
            />
        );
    }

    return (
        <NotificationWidget
            head={viewData!.head}
            items={viewData!.items}
            link={{
                text: "Alle meldingen bekijken",
                onClick: () => {
                    navigate(RouteEnum.NOTIFICATIONS);
                },
            }}
        />
    );
};
